// src/types/workspace-developer/WorkspaceDeveloperEnums.ts
var WorkspaceDeveloperState = /* @__PURE__ */ ((WorkspaceDeveloperState2) => {
  WorkspaceDeveloperState2["None"] = "none";
  WorkspaceDeveloperState2["Requested"] = "requested";
  WorkspaceDeveloperState2["Accepted"] = "accepted";
  WorkspaceDeveloperState2["Active"] = "active";
  WorkspaceDeveloperState2["Declined"] = "declined";
  WorkspaceDeveloperState2["Revoked"] = "revoked";
  return WorkspaceDeveloperState2;
})(WorkspaceDeveloperState || {});
var WorkspaceDeveloperEnvironment = /* @__PURE__ */ ((WorkspaceDeveloperEnvironment2) => {
  WorkspaceDeveloperEnvironment2["Live"] = "live";
  WorkspaceDeveloperEnvironment2["Sandbox"] = "sandbox";
  return WorkspaceDeveloperEnvironment2;
})(WorkspaceDeveloperEnvironment || {});
var WorkspaceDeveloperRequestSeriesGranularity = /* @__PURE__ */ ((WorkspaceDeveloperRequestSeriesGranularity2) => {
  WorkspaceDeveloperRequestSeriesGranularity2["Day"] = "day";
  WorkspaceDeveloperRequestSeriesGranularity2["Hour"] = "hour";
  return WorkspaceDeveloperRequestSeriesGranularity2;
})(WorkspaceDeveloperRequestSeriesGranularity || {});

export {
  WorkspaceDeveloperState,
  WorkspaceDeveloperEnvironment,
  WorkspaceDeveloperRequestSeriesGranularity
};
